import { mapActions } from 'vuex';
import Events from '_utils/events';
import PuzzleService from '_services/rest/modules/puzzle-term';
import { _UPDATE_PUZZLE_PAGINATION_ } from './PuzzleTermModel';

export default {
  name: 'puzzle-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      PuzzleService.deletePuzzle(this.selectPuzzle)
        .then(() => {
          this.close();
          Events.$emit(_UPDATE_PUZZLE_PAGINATION_, { page: 1 });
          this.activeAlert({ message: 'Jogo deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
